var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section basicInfoForm", staticStyle: { height: "auto" } },
    [
      _c(
        "div",
        { staticClass: "inner-row" },
        [
          _c(
            "el-form",
            {
              staticClass: "form-item-400",
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "105px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "margin-Right90",
                  attrs: { label: _vm.$t("baseInfo.partner.cmpIdx") }
                },
                [
                  _c("el-input", {
                    attrs: { no: "cmpIdx", disabled: true },
                    model: {
                      value: _vm.form.cmpIdx,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "cmpIdx", $$v)
                      },
                      expression: "form.cmpIdx"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("baseInfo.partner.chineseName"),
                    "label-width": _vm.isZh ? "105px" : "120px",
                    required: true
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-input", {
                        staticStyle: { "flex-grow": "1" },
                        attrs: {
                          no: "chineseName",
                          disabled:
                            !!_vm.form.globalAccountUuid || _vm.oujianEditLimit,
                          "filter-chars": false
                        },
                        on: { change: _vm.checkChineseName },
                        model: {
                          value: _vm.form.chineseName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "chineseName", $$v)
                          },
                          expression: "form.chineseName"
                        }
                      }),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "light",
                            content: _vm.$t(
                              "Partners.industrialAndCommercialInformationQuery"
                            ),
                            placement: "right-end"
                          }
                        },
                        [
                          _c(
                            "a",
                            {
                              style: _vm.form.chineseName
                                ? ""
                                : "pointer-events: none;",
                              attrs: {
                                href: _vm.tianYanChaUrl,
                                target: "_blank"
                              }
                            },
                            [
                              _vm.showTianYanCha
                                ? _c("img", {
                                    staticStyle: {
                                      width: "20px",
                                      height: "20px"
                                    },
                                    attrs: { src: "/static/eyeInTheSky.png" }
                                  })
                                : _vm._e()
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "inner-row" },
        [
          _c(
            "el-form",
            {
              staticClass: "form-item-400",
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "105px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "margin-Right90",
                  attrs: {
                    label: _vm.$t("baseInfo.partner.shortName"),
                    required: true
                  }
                },
                [
                  _c("el-input", {
                    attrs: {
                      no: "shortName",
                      disabled:
                        !!_vm.form.globalAccountUuid || _vm.oujianEditLimit
                    },
                    model: {
                      value: _vm.form.shortName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "shortName", $$v)
                      },
                      expression: "form.shortName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("baseInfo.partner.englishName"),
                    "label-width": _vm.isZh ? "105px" : "120px",
                    required: true
                  }
                },
                [
                  _c("el-input", {
                    attrs: {
                      no: "englishName",
                      disabled: !!_vm.form.globalAccountUuid,
                      "filter-chars": false
                    },
                    on: { change: _vm.checkEnglishName },
                    model: {
                      value: _vm.form.englishName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "englishName", $$v)
                      },
                      expression: "form.englishName"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "inner-row" },
        [
          _c(
            "el-form",
            {
              staticClass: "form-item-400",
              attrs: {
                disabled: _vm.readonly || _vm.oujianEditLimit,
                inline: true,
                "label-width": "105px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "margin-Right90",
                  attrs: { label: _vm.$t("baseInfo.partner.cnShortName") }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "cnShortName",
                          disabled:
                            !!_vm.form.globalAccountUuid || _vm.yuhaiApiIsEdit
                        },
                        on: { change: _vm.checkCnShortName },
                        model: {
                          value: _vm.form.cnShortName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cnShortName", $$v)
                          },
                          expression: "form.cnShortName"
                        }
                      }),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { width: "80px", "margin-left": "5px" },
                          attrs: {
                            no: "active",
                            disabled: !_vm.activeEnabled || _vm.yuhaiApiIsEdit
                          },
                          on: { change: _vm.onActiveChange },
                          model: {
                            value: _vm.form.active,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "active", $$v)
                            },
                            expression: "form.active"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Partners.activity")))]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { display: "block", "margin-top": "5px" },
                  attrs: { label: _vm.$t("Partners.inactiveReason") }
                },
                [
                  _c("el-input", {
                    attrs: { no: "inactiveReason", disabled: _vm.form.active },
                    model: {
                      value: _vm.form.inactiveReason,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "inactiveReason", $$v)
                      },
                      expression: "form.inactiveReason"
                    }
                  })
                ],
                1
              ),
              _vm.hbBranchIdVisible
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("baseInfo.partner.branchId"),
                        "label-width": _vm.isZh ? "105px" : "120px"
                      }
                    },
                    [
                      _c("cargo-owned-branch-select", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          no: "branchId",
                          disabled: _vm.oujianEditLimit,
                          "select-type":
                            _vm.selectTypeNames.basic_data_Office_All,
                          "refresh-id": _vm.refreshId
                        },
                        on: { change: _vm.changeCustomerDept },
                        model: {
                          value: _vm.form.branchId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "branchId", $$v)
                          },
                          expression: "form.branchId"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "inner-row" },
        [
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "105px",
                "label-position": "left"
              }
            },
            [
              !_vm.isSalesForSzfs
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Partners.crossTenantAuthorize"),
                        "label-width": _vm.isZh ? "105px" : "160px"
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "useCrossTenant" },
                          on: { change: _vm.onCrossTenantChange },
                          model: {
                            value: _vm.useCrossTenant,
                            callback: function($$v) {
                              _vm.useCrossTenant = $$v
                            },
                            expression: "useCrossTenant"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Message.Agree")))]
                      ),
                      _c(
                        "el-link",
                        {
                          style:
                            "margin-left: 10px;font-size: 12px;line-height: 12px;width:" +
                            (_vm.isZh ? "98px" : "185.23px"),
                          attrs: { disabled: _vm.readonly, type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.agreementDialog.visible = true
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("Partners.crossTenantAuthorizeAgreement")
                            )
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  style: !_vm.isSalesForSzfs
                    ? { marginLeft: _vm.isZh ? "238px" : "90px" }
                    : "",
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_ApplicationBranch1"),
                    "label-width": _vm.$selectByLang("105px", "120px")
                  }
                },
                [
                  _c("cargo-owned-branch-select", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      value: _vm.toNumArray(_vm.form.multipleBranchId),
                      no: "multipleBranchId",
                      "select-type": _vm.selectTypeNames.basic_data_Office_All,
                      "static-options": _vm.branchCompanyHierarchy
                        ? _vm.currentOfficeList
                        : null,
                      "refresh-id": _vm.multipleRefreshId,
                      multiple: true
                    },
                    on: {
                      input: function(val) {
                        _vm.form.multipleBranchId = _vm.toTxt(val)
                      }
                    }
                  }),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "5px" },
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.showBranchSelectDialog }
                    },
                    [_vm._v("...")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "inner-row" },
        [
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "105px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "margin-Right90",
                  attrs: { label: _vm.$t("Partners.theOtherPlatformID") }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "295px" },
                        attrs: {
                          no: "relateTenantId",
                          disabled:
                            !_vm.useCrossTenant || !!_vm.form.globalAccountUuid,
                          "select-type": _vm.selectTypeNames.TENANT,
                          cache: false,
                          filterable: "",
                          "show-custom-label-in-option": true,
                          "custom-label": _vm.companyLabel,
                          "callback-params": { key: "relateTenantId" },
                          "callback-method-type": "value",
                          "default-value": String(
                            _vm.form.relateTenantId || ""
                          ),
                          "static-options": _vm.tenants
                        },
                        on: { parentCallBack: _vm.tenantIdChangeHandler }
                      }),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "100px", "margin-left": "5px" },
                        attrs: {
                          no: "relateTenantOfficeId",
                          disabled:
                            !_vm.useCrossTenant ||
                            !_vm.form.relateTenantId ||
                            !!_vm.form.globalAccountUuid,
                          "select-type": _vm.selectTypeNames.static_data_Office,
                          "method-params": {
                            tenantId: _vm.form.relateTenantId
                          },
                          filterable: "",
                          clearable: false,
                          "callback-params": { key: "relateTenantOfficeId" },
                          "callback-method-type": "value",
                          fields: ["code"],
                          "tag-name": "code",
                          "tag-value": "officeId",
                          "default-value": _vm.form.relateTenantOfficeId || "",
                          "static-options": _vm.tenantOfficeList
                        },
                        on: { parentCallBack: _vm.selectCargoItem }
                      }),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.isNewDelegation && _vm.form.linkedBranchId,
                              expression: "isNewDelegation&&form.linkedBranchId"
                            }
                          ],
                          staticStyle: { "margin-left": "10px" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("Partners.relatedBranch")) +
                              "：" +
                              _vm._s(_vm.form.linkedBranchCode)
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("Partners.isParentCompany"),
                    "label-width": _vm.$selectByLang("105px", "160px", "105px")
                  }
                },
                [
                  _c("el-checkbox", {
                    attrs: { no: "parentCompany" },
                    on: { change: _vm.parentCompanyChange },
                    model: {
                      value: _vm.form.parentCompany,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "parentCompany", $$v)
                      },
                      expression: "form.parentCompany"
                    }
                  })
                ],
                1
              ),
              _vm.extendedInterestRate
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-left": "30px" },
                      attrs: {
                        label: _vm.$t("Partners.interestFreeCompany"),
                        "label-width": _vm.isZh ? "100px" : "160px"
                      }
                    },
                    [
                      _c("el-checkbox", {
                        attrs: { no: "interestFree" },
                        model: {
                          value: _vm.form.interestFree,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "interestFree", $$v)
                          },
                          expression: "form.interestFree"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-left": "30px" },
                  attrs: { label: _vm.$t("Partners.isFba") }
                },
                [
                  _c("el-checkbox", {
                    attrs: { no: "fba", disabled: !_vm.form.customer },
                    model: {
                      value: _vm.form.fba,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "fba", $$v)
                      },
                      expression: "form.fba"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-left": "30px" },
                  attrs: {
                    label: _vm.$t("Partners.isInternalCorrespondent"),
                    "label-width": "110px"
                  }
                },
                [
                  _c("el-checkbox", {
                    attrs: { no: "internalCorrespondent" },
                    model: {
                      value: _vm.form.internalCorrespondent,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "internalCorrespondent", $$v)
                      },
                      expression: "form.internalCorrespondent"
                    }
                  })
                ],
                1
              ),
              _vm.showUnifiedSign
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-left": "30px" },
                      attrs: { label: _vm.$t("Partners.UnifiedSign") }
                    },
                    [
                      _c("el-checkbox", {
                        attrs: { no: "unifiedSign" },
                        model: {
                          value: _vm.form.unifiedSign,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "unifiedSign", $$v)
                          },
                          expression: "form.unifiedSign"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showIfRisk
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-left": "30px" },
                      attrs: { label: _vm.$t("Partners.IfRisk") }
                    },
                    [
                      _c("el-checkbox", {
                        attrs: { no: "ifRisk", disabled: _vm.oujianEditLimit },
                        model: {
                          value: _vm.form.ifRisk,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "ifRisk", $$v)
                          },
                          expression: "form.ifRisk"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.form.seaCmp
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-left": "30px" },
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_IfExistMblNumberRange"),
                        "label-width": "110px"
                      }
                    },
                    [
                      _c("el-checkbox", {
                        attrs: { no: "ifExistMblNumberRange" },
                        model: {
                          value: _vm.form.ifExistMblNumberRange,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "ifExistMblNumberRange", $$v)
                          },
                          expression: "form.ifExistMblNumberRange"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm.form.customer || _vm.form.overseaAgent || _vm.form.designationAgent
        ? _c(
            "div",
            { staticClass: "inner-row" },
            [
              _c(
                "el-form",
                {
                  staticClass: "form-item-400",
                  attrs: {
                    disabled: _vm.readonly,
                    inline: true,
                    "label-width": "105px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "margin-Right90",
                      attrs: { label: _vm.$t("CargoMsg.Cargo_WarehouseCode") }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-input", {
                            staticStyle: { "flex-grow": "1" },
                            attrs: { no: "warehouseCode" },
                            model: {
                              value: _vm.form.warehouseCode,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "warehouseCode", $$v)
                              },
                              expression: "form.warehouseCode"
                            }
                          }),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.$t(
                                  "CargoMsg.Cargo_WarehouseCodeLengthLimit"
                                )
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning",
                                staticStyle: {
                                  color: "#e6a23c",
                                  "margin-left": "5px"
                                }
                              })
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-form",
        {
          staticClass: "form-item-400",
          attrs: {
            disabled: _vm.readonly,
            inline: true,
            "label-width": "120px",
            "label-position": "left"
          }
        },
        [
          _c("el-form-item", { attrs: { label: " " } }, [
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c("el-checkbox", {
                  staticStyle: { "margin-right": "5px" },
                  attrs: {
                    title: _vm.$t("CargoMsg.Cargo_DesignatedCargoWarehouseNo"),
                    no: "designatedCargoWarehouseNo"
                  },
                  model: {
                    value: _vm.form.designatedCargoWarehouseNo,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "designatedCargoWarehouseNo", $$v)
                    },
                    expression: "form.designatedCargoWarehouseNo"
                  }
                }),
                _vm._v(
                  _vm._s(_vm.$t("CargoMsg.Cargo_DesignatedCargoWarehouseNo")) +
                    " "
                ),
                _c("el-checkbox", {
                  staticStyle: { "padding-left": "5px", "margin-right": "5px" },
                  attrs: {
                    title: _vm.$t("CargoMsg.Cargo_SelfCargoWarehouseNo"),
                    no: "selfCargoWarehouseNo"
                  },
                  model: {
                    value: _vm.form.selfCargoWarehouseNo,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "selfCargoWarehouseNo", $$v)
                    },
                    expression: "form.selfCargoWarehouseNo"
                  }
                }),
                _vm._v(
                  _vm._s(_vm.$t("CargoMsg.Cargo_SelfCargoWarehouseNo")) + " "
                )
              ],
              1
            )
          ]),
          _c("el-form-item", { attrs: { label: " " } }, [
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c("el-checkbox", {
                  staticStyle: { "padding-left": "5px", "margin-right": "5px" },
                  attrs: {
                    no: "specialFeePaymentLimit",
                    title: _vm.$t("CargoMsg.Cargo_SpecialFeePaymentLimit")
                  },
                  model: {
                    value: _vm.form.specialFeePaymentLimit,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "specialFeePaymentLimit", $$v)
                    },
                    expression: "form.specialFeePaymentLimit"
                  }
                }),
                _vm._v(
                  _vm._s(_vm.$t("CargoMsg.Cargo_SpecialFeePaymentLimit")) + " "
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm.serviceType === _vm.PartnerServiceItem.PARTNER_SERVICE_ALL.code
        ? _c(
            "div",
            {
              staticClass: "inner-row",
              staticStyle: { "padding-top": "10px", "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    inline: true,
                    "label-width": "50px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.Roles"),
                        required: true
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: {
                            no: "customer",
                            disabled:
                              !!_vm.isNewDelegation && !!_vm.form.linkedBranchId
                          },
                          on: { change: _vm.checkCustomerFunc },
                          model: {
                            value: _vm.form.customer,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "customer", $$v)
                            },
                            expression: "form.customer"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Payment.customer")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: {
                            no: "bookingAgent",
                            disabled:
                              !!_vm.isNewDelegation &&
                              !!_vm.form.linkedBranchId,
                            title: _vm.$t("SeaExport.BookingOrExchangeAgent")
                          },
                          model: {
                            value: _vm.form.bookingAgent,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "bookingAgent", $$v)
                            },
                            expression: "form.bookingAgent"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.BookingOrExchangeAgent"))
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "seaCmpAgent" },
                          model: {
                            value: _vm.form.seaCmpAgent,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "seaCmpAgent", $$v)
                            },
                            expression: "form.seaCmpAgent"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.CarrierAgent")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: {
                            no: "overseaAgent",
                            disabled: _vm.form.designationAgent,
                            title: _vm.$t("Payment.destinationAgent")
                          },
                          model: {
                            value: _vm.form.overseaAgent,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "overseaAgent", $$v)
                            },
                            expression: "form.overseaAgent"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Payment.destinationAgent")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: {
                            no: "designationAgent",
                            disabled:
                              _vm.readonly ||
                              !_vm.$checkPermission([
                                "filter_partner_overseasAgent"
                              ]),
                            title: _vm.$t("queryJob.nominatedAgent")
                          },
                          on: { change: _vm.designationAgentChangeHandler },
                          model: {
                            value: _vm.form.designationAgent,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "designationAgent", $$v)
                            },
                            expression: "form.designationAgent"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("queryJob.nominatedAgent")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "localAgent" },
                          model: {
                            value: _vm.form.localAgent,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "localAgent", $$v)
                            },
                            expression: "form.localAgent"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.LocalAgent")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: {
                            no: "settlementAgent",
                            title: _vm.$t("Payment.settlementAgent")
                          },
                          on: { change: _vm.checkSettleAgentFunc },
                          model: {
                            value: _vm.form.settlementAgent,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "settlementAgent", $$v)
                            },
                            expression: "form.settlementAgent"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Payment.settlementAgent")))]
                      ),
                      _vm.seaCarrierVisible
                        ? _c(
                            "el-checkbox",
                            {
                              attrs: { no: "seaCarrierVisible" },
                              model: {
                                value: _vm.form.seaCmp,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "seaCmp", $$v)
                                },
                                expression: "form.seaCmp"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.ShippingCompany"))
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.airCarrierVisible
                        ? _c(
                            "el-checkbox",
                            {
                              attrs: { no: "airCarrierVisible" },
                              model: {
                                value: _vm.form.airCmp,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "airCmp", $$v)
                                },
                                expression: "form.airCmp"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.AirlineCompany")))]
                          )
                        : _vm._e(),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "customsBroker" },
                          model: {
                            value: _vm.form.customsBroker,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "customsBroker", $$v)
                            },
                            expression: "form.customsBroker"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.CustomsBroker")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "warehouse" },
                          model: {
                            value: _vm.form.warehouse,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "warehouse", $$v)
                            },
                            expression: "form.warehouse"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Warehouse")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "truckCmp" },
                          model: {
                            value: _vm.form.truckCmp,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "truckCmp", $$v)
                            },
                            expression: "form.truckCmp"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Partners.isTruckCmp")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "shipper" },
                          model: {
                            value: _vm.form.shipper,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "shipper", $$v)
                            },
                            expression: "form.shipper"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Message.Shipper")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "consignee" },
                          model: {
                            value: _vm.form.consignee,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "consignee", $$v)
                            },
                            expression: "form.consignee"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Message.Consignee")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "notify" },
                          model: {
                            value: _vm.form.notify,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "notify", $$v)
                            },
                            expression: "form.notify"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Message.Notify")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "portAgent" },
                          model: {
                            value: _vm.form.portAgent,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "portAgent", $$v)
                            },
                            expression: "form.portAgent"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Partners.portAgent")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: {
                            no: "forwardingAgent",
                            title: _vm.$t("Partners.forwardingAgent")
                          },
                          model: {
                            value: _vm.form.forwardingAgent,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "forwardingAgent", $$v)
                            },
                            expression: "form.forwardingAgent"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Partners.forwardingAgent")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: {
                            no: "loadingPlaceCompany",
                            title: _vm.$t("Partners.loadingPlaceCompany")
                          },
                          model: {
                            value: _vm.form.loadingPlaceCompany,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "loadingPlaceCompany", $$v)
                            },
                            expression: "form.loadingPlaceCompany"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Partners.loadingPlaceCompany")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: {
                            no: "signBillPlaceCompany",
                            title: _vm.$t("Partners.signBillPlaceCompany")
                          },
                          model: {
                            value: _vm.form.signBillPlaceCompany,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "signBillPlaceCompany", $$v)
                            },
                            expression: "form.signBillPlaceCompany"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("Partners.signBillPlaceCompany"))
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: {
                            no: "dischargePortCompany",
                            title: _vm.$t("Partners.dischargePortCompany")
                          },
                          model: {
                            value: _vm.form.dischargePortCompany,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "dischargePortCompany", $$v)
                            },
                            expression: "form.dischargePortCompany"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("Partners.dischargePortCompany"))
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: {
                            no: "destinationPortCompany",
                            title: _vm.$t("Partners.destinationPortCompany")
                          },
                          model: {
                            value: _vm.form.destinationPortCompany,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "destinationPortCompany", $$v)
                            },
                            expression: "form.destinationPortCompany"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("Partners.destinationPortCompany"))
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "tradersSign" },
                          model: {
                            value: _vm.form.tradersSign,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "tradersSign", $$v)
                            },
                            expression: "form.tradersSign"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Partners.traders")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: {
                            no: "factorySign",
                            title: _vm.$selectByLang(
                              _vm.$t("Partners.Factory") +
                                "/" +
                                _vm.$t("Order.Producer"),
                              _vm.$t("Partners.Factory") +
                                "/" +
                                _vm.$t("Order.Producer"),
                              _vm.$t("Order.Producer")
                            )
                          },
                          model: {
                            value: _vm.form.factorySign,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "factorySign", $$v)
                            },
                            expression: "form.factorySign"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$selectByLang(
                                  _vm.$t("Partners.Factory") +
                                    "/" +
                                    _vm.$t("Order.Producer"),
                                  _vm.$t("Partners.Factory") +
                                    "/" +
                                    _vm.$t("Order.Producer"),
                                  _vm.$t("Order.Producer")
                                )
                              ) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "other" },
                          model: {
                            value: _vm.form.other,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "other", $$v)
                            },
                            expression: "form.other"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Message.Other")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: {
                            no: "terminalCompany",
                            title: _vm.$t("Message.TerminalCompany")
                          },
                          model: {
                            value: _vm.form.terminalCompany,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "terminalCompany", $$v)
                            },
                            expression: "form.terminalCompany"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Message.TerminalCompany")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.serviceType === _vm.PartnerServiceItem.PARTNER_AGENT.code
        ? _c(
            "div",
            {
              staticClass: "inner-row",
              staticStyle: { "padding-top": "10px", "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    inline: true,
                    "label-width": "105px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { class: _vm.clazz.checkNormal, attrs: { label: " " } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: {
                            no: "overseaAgent",
                            disabled: _vm.form.designationAgent,
                            title: _vm.$t("Payment.destinationAgent")
                          },
                          model: {
                            value: _vm.form.overseaAgent,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "overseaAgent", $$v)
                            },
                            expression: "form.overseaAgent"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Payment.destinationAgent")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: {
                            no: "designationAgent",
                            disabled:
                              _vm.readonly ||
                              !_vm.$checkPermission([
                                "filter_partner_overseasAgent"
                              ]),
                            title: _vm.$t("queryJob.nominatedAgent")
                          },
                          on: { change: _vm.designationAgentChangeHandler },
                          model: {
                            value: _vm.form.designationAgent,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "designationAgent", $$v)
                            },
                            expression: "form.designationAgent"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("queryJob.nominatedAgent")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "inner-row" },
        [
          _c(
            "el-form",
            {
              staticClass: "form-item-400",
              attrs: {
                inline: true,
                "label-width": "105px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.differentiateCustomerAndSupplierFees,
                      expression: "differentiateCustomerAndSupplierFees"
                    }
                  ],
                  class: _vm.isZh
                    ? "margin-Right90 checkbox-50"
                    : "margin-Right90 checkbox-en-50",
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_CategoryOfPartner") + "：",
                    required: true
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: {
                        disabled: _vm.readonly || _vm.oujianEditLimit,
                        value: _vm.form.ifCustomer,
                        no: "ifCustomer"
                      },
                      on: { change: _vm.customerChangeHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("Partners.isCustomer")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: {
                        disabled: _vm.readonly || _vm.oujianEditLimit,
                        value: _vm.form.ifSupplier,
                        no: "ifSupplier"
                      },
                      on: { change: _vm.supplierChangeHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Supplier")))]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.seaCmp,
                      expression: "form.seaCmp"
                    }
                  ],
                  attrs: {
                    label: _vm.$t(
                      "CargoMsg.Cargo_AssociatedPlatformShippingCompany"
                    )
                  }
                },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "associatedPlatformShippingCompany",
                      disabled: _vm.readonly,
                      "static-options": _vm.shipCompanyInfos,
                      filterable: "",
                      "filter-tag-names": [
                        "shipCompanyChineseName",
                        "shipCompanyEnglishName",
                        "shipCompanyCode"
                      ],
                      "tag-name": "shipCompanyEnglishName",
                      "tag-value": "uuid",
                      "default-value": _vm.form.shipCompanyUuid || ""
                    },
                    on: {
                      parentCallBack: _vm.selectShipCompany,
                      clear: _vm.clearShipCompany
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.seaCmp,
                      expression: "form.seaCmp"
                    }
                  ],
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_ShipCompanyThirdPartyCode")
                  }
                },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "shipCompanyExternalCode"
                    },
                    model: {
                      value: _vm.form.externalCode,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "externalCode", $$v)
                      },
                      expression: "form.externalCode"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "inner-row" },
        [
          _c(
            "el-form",
            {
              staticClass: "form-item-400",
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "105px",
                "label-position": "left"
              }
            },
            [
              _vm.form.customer
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.TradeTerms2") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "incoTerm",
                          "select-type":
                            _vm.selectTypeNames.basic_data_IncoTerm,
                          filterable: "",
                          multiple: true,
                          "default-multiple-value": _vm.incoTerms,
                          clearable: false,
                          placeholder: _vm.defaultIncoTerm
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.incoTerms = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "inner-row" },
        [
          _c(
            "el-form",
            {
              staticClass: "form-item-400",
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "105px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "margin-Right90",
                  attrs: { label: _vm.$t("Partners.customerCode") }
                },
                [
                  _c("el-input", {
                    attrs: { no: "externalKeyCust" },
                    model: {
                      value: _vm.form.externalKeyCust,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "externalKeyCust", $$v)
                      },
                      expression: "form.externalKeyCust"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Partners.supplierCode") } },
                [
                  _c("el-input", {
                    attrs: { no: "externalKeyVend" },
                    model: {
                      value: _vm.form.externalKeyVend,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "externalKeyVend", $$v)
                      },
                      expression: "form.externalKeyVend"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "inner-row" },
        [
          _c(
            "el-form",
            {
              staticClass: "form-item-400",
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "105px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  class: _vm.isZh
                    ? "margin-Right90 checkbox-50"
                    : "margin-Right90 checkbox-en-50",
                  attrs: {
                    label: _vm.$t("Partners.relatedBusinessType") + "：",
                    required: true
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "seaExport" },
                      model: {
                        value: _vm.form.seaExport,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "seaExport", $$v)
                        },
                        expression: "form.seaExport"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("constant.systemConstants.SE")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "seaImport" },
                      model: {
                        value: _vm.form.seaImport,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "seaImport", $$v)
                        },
                        expression: "form.seaImport"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("constant.systemConstants.SI")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "airExport" },
                      model: {
                        value: _vm.form.airExport,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "airExport", $$v)
                        },
                        expression: "form.airExport"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("constant.systemConstants.AE")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "airImport" },
                      model: {
                        value: _vm.form.airImport,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "airImport", $$v)
                        },
                        expression: "form.airImport"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("constant.systemConstants.AI")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "railwayExport" },
                      model: {
                        value: _vm.form.railwayExport,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "railwayExport", $$v)
                        },
                        expression: "form.railwayExport"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("constant.systemConstants.RB")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "integratedJob" },
                      model: {
                        value: _vm.form.integratedJob,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "integratedJob", $$v)
                        },
                        expression: "form.integratedJob"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("constant.systemConstants.IE")))]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isNewDelegation,
                      expression: "!isNewDelegation"
                    }
                  ],
                  attrs: { label: _vm.$t("Partners.relatedBranch") }
                },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "linkedBranchId",
                      "select-type": _vm.selectTypeNames.basic_data_Office,
                      filterable: "",
                      "callback-params": { key: "linkedBranchId" },
                      "callback-method-type": "value",
                      headers: [],
                      fields: ["code"],
                      "tag-name": "code",
                      "default-value": _vm.form.linkedBranchId || ""
                    },
                    on: { parentCallBack: _vm.selectCargoItem }
                  })
                ],
                1
              ),
              _c("br", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isNewDelegation,
                    expression: "!isNewDelegation"
                  }
                ]
              }),
              _c(
                "el-form-item",
                { staticClass: "margin-Right90", attrs: { label: "SCAC" } },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "scac",
                      disabled: _vm.scacDisabled,
                      "select-type": _vm.selectTypeNames.SCAC_CODES,
                      cache: false,
                      filterable: "",
                      "callback-params": { key: "scac" },
                      "callback-method-type": "value",
                      "default-value": _vm.form.scac,
                      "allow-create": true,
                      "tag-name": "scac",
                      "show-custom-label-in-option": true,
                      "custom-label": _vm.scacLabel
                    },
                    on: { parentCallBack: _vm.onScacChange }
                  })
                ],
                1
              ),
              _c("br", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.seaCmp,
                    expression: "form.seaCmp"
                  }
                ]
              }),
              _vm.form.seaCmp
                ? _c(
                    "el-form-item",
                    { attrs: { label: "EORI" } },
                    [
                      _c("so-no-input", {
                        attrs: {
                          no: "86",
                          title: "EORI ",
                          disabled: _vm.readonly
                        },
                        model: {
                          value: _vm.form.eori,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "eori", $$v)
                          },
                          expression: "form.eori"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c("br", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isNewDelegation,
                    expression: "isNewDelegation"
                  }
                ]
              }),
              _vm.isZY
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.BookingAgentLevel") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "bookingAgentLevel",
                          disabled: false,
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_BookingAgentLevel$BOOKING_AGENT_LEVEL,
                          filterable: "",
                          "default-value": _vm.form.bookingAgentLevel || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            return (_vm.form.bookingAgentLevel = p.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "inner-row" },
        [
          _c(
            "el-form",
            {
              staticClass: "form-item-400",
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "105px",
                "label-position": "left"
              }
            },
            [
              _vm.showSupplierDepartment
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.supplierDepartment") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "400px" },
                          attrs: {
                            no: "supplierDepartmentUuids",
                            multiple: "",
                            filterable: "",
                            clearable: "",
                            placeholder: "请下拉选择",
                            "popper-class": "supplier-department-select"
                          },
                          model: {
                            value: _vm.supplierDepartmentUuids,
                            callback: function($$v) {
                              _vm.supplierDepartmentUuids = $$v
                            },
                            expression: "supplierDepartmentUuids"
                          }
                        },
                        _vm._l(_vm.supplierDepartmentOptions, function(item) {
                          return _c("el-option", {
                            key: item.uuid,
                            attrs: {
                              label: _vm.isZh
                                ? item.departmentName
                                : item.departmentCode,
                              value: item.uuid
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "inner-row" },
        [
          _c(
            "el-form",
            {
              staticClass: "form-item-400",
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "105px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "margin-Right90",
                  attrs: { label: _vm.$t("Partners.paymentType") + "：" }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: {
                            no: "collection",
                            title: _vm.$t("Partners.whetherCollection")
                          },
                          model: {
                            value: _vm.form.collection,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "collection", $$v)
                            },
                            expression: "form.collection"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Partners.whetherCollection")))]
                      ),
                      _vm.isZhongyouAdvancePaymentOpen
                        ? _c(
                            "el-radio-group",
                            {
                              staticStyle: { "padding-top": "6px" },
                              attrs: { disabled: !_vm.isAdd },
                              model: {
                                value: _vm.form.ifAdvancePayment,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "ifAdvancePayment", $$v)
                                },
                                expression: "form.ifAdvancePayment"
                              }
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: { no: "underestimation", label: false }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("Partners.Underestimation"))
                                  )
                                ]
                              ),
                              _c(
                                "el-radio",
                                {
                                  attrs: { no: "ifAdvancePayment", label: true }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("Partners.IfAdvancePayment"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _vm.form.truckCmp
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.fleetCode") } },
                    [
                      _c("el-input", {
                        attrs: { no: "plateCode" },
                        model: {
                          value: _vm.form.plateCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "plateCode", $$v)
                          },
                          expression: "form.plateCode"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c("br", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.truckCmp,
                    expression: "form.truckCmp"
                  }
                ]
              }),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Partners.platformSupplier") } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { "margin-right": "5px", width: "400px" },
                      attrs: { no: "platformProvider", clearable: "" },
                      model: {
                        value: _vm.form.platformProvider,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "platformProvider", $$v)
                        },
                        expression: "form.platformProvider"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.isZh
                            ? _vm.$t("Partners.ouJian")
                            : "ouJian",
                          value: "OJ"
                        }
                      }),
                      _vm._l(_vm.platFormSuppliers, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            label: _vm.isZh
                              ? item.chineseName
                              : item.englishName,
                            value: item.code
                          }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "defaultAccount" },
                      model: {
                        value: _vm.form.defaultAccount,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "defaultAccount", $$v)
                        },
                        expression: "form.defaultAccount"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("Partners.DefaultSettlementForInsurance"))
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isSalesForSzfs,
              expression: "!isSalesForSzfs"
            }
          ],
          staticClass: "inner-row",
          staticStyle: { "padding-left": "121px" }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "100px",
                "label-position": "left"
              }
            },
            [
              _c("el-form-item", { attrs: { "label-width": "0" } }, [
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: {
                          no: "useSettlementAgent",
                          title: _vm.$t("Partners.usingSettlementAgent")
                        },
                        model: {
                          value: _vm.useSettlementAgent,
                          callback: function($$v) {
                            _vm.useSettlementAgent = $$v
                          },
                          expression: "useSettlementAgent"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("Partners.usingSettlementAgent")))]
                    ),
                    _c("cargo-advance-select", {
                      style: {
                        "margin-left": "10px",
                        width: _vm.isZh ? "290px" : "250px"
                      },
                      attrs: {
                        no: "settlementAgent",
                        disabled: !_vm.useSettlementAgent,
                        "select-type": _vm.selectTypeNames.static_data_Company,
                        url: _vm.url.partner.settlementAgent,
                        "method-params": { officeId: _vm.currentOfficeId },
                        cache: false,
                        filterable: "",
                        "callback-params": {},
                        "callback-method-type": "value",
                        multiple: true,
                        "default-multiple-value": _vm.settlementAgents,
                        "tag-value": "uuid",
                        placeholder: _vm.defaultPlaceholder
                      },
                      on: {
                        parentCallBack: function(item) {
                          return (_vm.settlementAgents = item.value)
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "inner-row" },
        [
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "105px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Partners.ParentCompany") } },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      no: "parentCompany",
                      disabled: _vm.form.parentCompany,
                      cache: false,
                      filterable: "",
                      "show-custom-label-in-option": true,
                      "custom-label": _vm.parentCompanyLabel,
                      "callback-params": { key: "globalAccountUuid" },
                      "callback-method-type": "value",
                      "default-value": _vm.form.globalAccountUuid || "",
                      "static-options": _vm.parentCompanyArray
                    },
                    on: { parentCallBack: _vm.selectCargoItem }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.seaCmp,
                      expression: "form.seaCmp"
                    }
                  ],
                  staticStyle: { "padding-left": "80px" },
                  attrs: { label: "" }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { width: "105px" },
                          attrs: {
                            no: "mscSupplement",
                            title: _vm.$t("CargoMsg.Cargo_ShowTab")
                          },
                          model: {
                            value: _vm.form.mscSupplement,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "mscSupplement", $$v)
                            },
                            expression: "form.mscSupplement"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ShowTab")))]
                      ),
                      _c(
                        "el-select",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.mscSupplement,
                              expression: "form.mscSupplement"
                            }
                          ],
                          staticStyle: { "padding-right": "40px" },
                          attrs: { no: "mscSupplementType", filterable: "" },
                          model: {
                            value: _vm.form.mscSupplementType,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "mscSupplementType", $$v)
                            },
                            expression: "form.mscSupplementType"
                          }
                        },
                        _vm._l(
                          _vm.SystemConstants.MSC_SUPPLEMENT_TYPE_LIST,
                          function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label:
                                  _vm.$store.getters.language === "zh"
                                    ? item.chineseName
                                    : item.englishName,
                                value: item.code
                              }
                            })
                          }
                        ),
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "inner-row" },
        [
          _c(
            "el-form",
            {
              staticClass: "form-item-200",
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "105px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-right": "0" },
                  attrs: {
                    label:
                      _vm.$t("baseInfo.partner.region") +
                      "（" +
                      _vm.$t("baseInfo.partner.area") +
                      "）"
                  }
                },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "160px" },
                    attrs: {
                      no: "region",
                      "select-type": _vm.selectTypeNames.basic_data_Country,
                      filterable: "",
                      "callback-params": { key: "region" },
                      "callback-method-type": "value",
                      "default-value": _vm.form.region
                    },
                    on: { parentCallBack: _vm.selectCargoItem }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form",
            {
              staticClass: "form-item-200",
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-position": "right"
              }
            },
            [
              _c("cargo-area", {
                staticStyle: { display: "inline-block" },
                attrs: {
                  no: "city",
                  country: _vm.form.region,
                  province: _vm.form.province,
                  city: _vm.form.city,
                  district: _vm.form.districts,
                  "select-width": 165,
                  "city-label-width": "105"
                },
                on: {
                  "update:country": function($event) {
                    return _vm.$set(_vm.form, "region", $event)
                  },
                  "update:province": function($event) {
                    return _vm.$set(_vm.form, "province", $event)
                  },
                  "update:city": function($event) {
                    return _vm.$set(_vm.form, "city", $event)
                  },
                  "update:district": function($event) {
                    return _vm.$set(_vm.form, "districts", $event)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "inner-row" },
        [
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "105px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "form-item-400 margin-Right90",
                  attrs: {
                    label: _vm.$t("SeaExport.Addr"),
                    required: !_vm.isXy
                  }
                },
                [
                  _c("el-input", {
                    attrs: { no: "address", disabled: _vm.oujianEditLimit },
                    model: {
                      value: _vm.form.address,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "address", $$v)
                      },
                      expression: "form.address"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ZIP") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "150px" },
                    attrs: { no: "zipCode" },
                    model: {
                      value: _vm.form.zipCode,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "zipCode", $$v)
                      },
                      expression: "form.zipCode"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("Partners.supplierPrincipal"),
                    "label-width": "90px"
                  }
                },
                [
                  _c("cargo-user-select", {
                    staticStyle: { width: "150px" },
                    attrs: {
                      no: "supplierDirector",
                      "method-params": { category: "role" },
                      "default-value": _vm.form.supplierDirector || ""
                    },
                    on: {
                      change: function(p) {
                        _vm.form.supplierDirector = p.value || 0
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "inner-row" },
        [
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "105px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Tel") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "160px" },
                    attrs: { no: "tel" },
                    model: {
                      value: _vm.form.tel,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "tel", $$v)
                      },
                      expression: "form.tel"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "margin-Right90",
                  attrs: {
                    label: _vm.$t("SeaExport.Fax"),
                    "label-width": "70px"
                  }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "160px" },
                    attrs: { no: "fax" },
                    model: {
                      value: _vm.form.fax,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "fax", $$v)
                      },
                      expression: "form.fax"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "form-item-400",
                  attrs: { label: _vm.$t("Partners.website") }
                },
                [
                  _c("el-input", {
                    attrs: { no: "url" },
                    model: {
                      value: _vm.form.url,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "url", $$v)
                      },
                      expression: "form.url"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "inner-row" },
        [
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "105px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Partners.rmbAccount") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "160px" },
                    attrs: { no: "rmbAccount" },
                    model: {
                      value: _vm.form.rmbAccount,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "rmbAccount", $$v)
                      },
                      expression: "form.rmbAccount"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "margin-Right90",
                  attrs: {
                    label: _vm.$t("Partners.usdAccount"),
                    "label-width": "70px"
                  }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "160px" },
                    attrs: { no: "usdAccount" },
                    model: {
                      value: _vm.form.usdAccount,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "usdAccount", $$v)
                      },
                      expression: "form.usdAccount"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Payment.taxRate") } },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-input-number", {
                        attrs: { no: "taxRate", controls: false },
                        model: {
                          value: _vm.form.taxRate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "taxRate", $$v)
                          },
                          expression: "form.taxRate"
                        }
                      }),
                      _vm._v("% ")
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "inner-row" },
        [
          _c(
            "el-form",
            {
              staticClass: "form-item-400",
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "105px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "margin-Right90",
                  attrs: { label: _vm.$t("CargoMsg.Cargo_AccountAddr") }
                },
                [
                  _c("el-input", {
                    ref: "accountAddr",
                    attrs: { no: "accountAddr", type: "textarea", rows: 3 },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("CargoMsg.Cargo_AccountAddr"),
                          _vm.form.accountAddr,
                          function(val) {
                            _vm.form.accountAddr = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.accountAddr,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "accountAddr", $$v)
                      },
                      expression: "form.accountAddr"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AdditionalNotes") } },
                [
                  _c("el-input", {
                    attrs: { no: "remarks", type: "textarea", rows: 3 },
                    model: {
                      value: _vm.form.remarks,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "remarks", $$v)
                      },
                      expression: "form.remarks"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            id: "agreement-dialog",
            visible: _vm.agreementDialog.visible,
            title: _vm.$t(
              "Partners.crossTenantEntrustedBookingGeneralProtocol"
            ),
            width: "800px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.agreementDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center", "font-weight": "bold" } },
            [
              _vm._v(
                _vm._s(
                  _vm.$t("Partners.crossTenantEntrustedBookingGeneralProtocol")
                )
              )
            ]
          ),
          _c("pre", [
            _vm._v(
              "      " + _vm._s(_vm.$t("Partners.agreementContent")) + "\n    "
            )
          ]),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "close" },
                  on: {
                    click: function($event) {
                      _vm.agreementDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.Close")))]
              )
            ],
            1
          )
        ]
      ),
      _c("settleAgentDialog", {
        attrs: {
          visible: _vm.settleAgentDialog.visible,
          "c-list": _vm.settleAgentDialog.cList,
          func: _vm.settleAgentDialog.func,
          uuid: _vm.settleAgentDialog.uuid
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.settleAgentDialog, "visible", $event)
          }
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "198px" },
            attrs: {
              disabled: _vm.readonly,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.readonly,
                      expression: "!readonly"
                    }
                  ],
                  attrs: { no: "finishAdvanceText", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "advanceTextDialogClose" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("branch-select-dialog", {
        attrs: {
          visible: _vm.branchSelectDialog.visible,
          "office-list": _vm.branchCompanyHierarchy
            ? _vm.currentOfficeList
            : null,
          value: _vm.branchSelectDialog.value
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.branchSelectDialog, "visible", $event)
          },
          callback: _vm.branchSelectDialog.callback
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }